import { render, staticRenderFns } from "./HousingLetterModal.vue?vue&type=template&id=80c48eb0&"
import script from "./HousingLetterModal.vue?vue&type=script&lang=ts&"
export * from "./HousingLetterModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('80c48eb0')) {
      api.createRecord('80c48eb0', component.options)
    } else {
      api.reload('80c48eb0', component.options)
    }
    module.hot.accept("./HousingLetterModal.vue?vue&type=template&id=80c48eb0&", function () {
      api.rerender('80c48eb0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modals/LetterInLeui/HousingLetterModal.vue"
export default component.exports